import samenvatting from './energietransitie/samenvatting'
import voornemen from './energietransitie/1-voornemen'
import voornemen_1 from './energietransitie/1-1-voornemen'
import voornemen_2 from './energietransitie/1-2-voornemen'
import voornemen_3 from './energietransitie/1-3-voornemen'
import voornemen_4 from './energietransitie/1-4-voornemen'
import voornemen_5 from './energietransitie/1-5-voornemen'
import voornemen_6 from './energietransitie/1-6-voornemen'
import mer from './energietransitie/2-mer'
import mer_2_1 from './energietransitie/2-1-mer'
import mer_2_2 from './energietransitie/2-2-mer'
import mer_2_3 from './energietransitie/2-3-mer'
import kaders from './energietransitie/3-kaders'
import kaders_3_1 from './energietransitie/3-1-kaders'
import kaders_3_2 from './energietransitie/3-2-kaders'
import kaders_3_3 from './energietransitie/3-3-kaders'
import analyse_4 from './energietransitie/4-analyse'
import analyse_4_1 from './energietransitie/4-1-analyse'
import analyse_4_2 from './energietransitie/4-2-analyse'
import analyse_4_3 from './energietransitie/4-3-analyse'
import analyse_4_4 from './energietransitie/4-4-analyse'
import analyse_4_5 from './energietransitie/4-5-analyse'
import analyse_4_6 from './energietransitie/4-6-analyse'
import analyse_4_7 from './energietransitie/4-7-analyse'
import analyse_4_8 from './energietransitie/4-8-analyse'
import analyse_4_9 from './energietransitie/4-9-analyse'
import analyse_4_10 from './energietransitie/4-10-analyse'
import analyse_4_10_1 from './energietransitie/4-10-1-analyse'
import analyse_4_10_2 from './energietransitie/4-10-2-analyse'
import analyse_4_10_3 from './energietransitie/4-10-3-analyse'
import analyse_4_11 from './energietransitie/4-11-analyse'
import alternatief from './energietransitie/5-alternatief'
import alternatief_1 from './energietransitie/5-1-alternatief'
import alternatief_2 from './energietransitie/5-2-alternatief'
import alternatief_3 from './energietransitie/5-3-alternatief'
import alternatief_4 from './energietransitie/5-4-alternatief'
import alternatief_5 from './energietransitie/5-5-alternatief'
import alternatief_6 from './energietransitie/5-6-alternatief'
import alternatief_7 from './energietransitie/5-7-alternatief'
import alternatief_8 from './energietransitie/5-8-alternatief'
import kennisleemtes from './energietransitie/6-kennisleemtes'
import kennisleemtes_1 from './energietransitie/6-1-kennisleemtes'
import kennisleemtes_2 from './energietransitie/6-2-kennisleemtes'
import versiebeheer from './energietransitie/versiebeheer'
 
const data = {
  menu: [
    {
      title: "Samenvatting",
      link: "/energietransitie/samenvatting",
      data: samenvatting,      
      children: [],
    },
    {
      title: "1. Voornemen",
      link: "/energietransitie/1",
      data: voornemen,
      children: [
        {
          title: "1.1. Aanleiding herziening module Energietransitie",
          link: "/energietransitie/1/1",
          data: voornemen_1,
          children: [],
        },
        {
          title: "1.2. Onderdelen van de herziening module Energietransitie",
          link: "/energietransitie/1/2",
          data: voornemen_2,
          children: [],
        },
        {
          title: "1.3. Doel en scope van het MER",
          link: "/energietransitie/1/3",
          data: voornemen_3,
          children: [],
        },
        {
          title: "1.4. Aanpak MER op hoofdlijnen",
          link: "/energietransitie/1/4",
          data: voornemen_4,
          children: [],
        },
        {
          title: "1.5. Relatie tussen MER en herziening module Energietransitie",
          link: "/energietransitie/1/5",
          data: voornemen_5,
          children: [],
        },
        {
          title: "1.6. Relatie tussen MER en Monitor Leefomgeving PZH",
          link: "/energietransitie/1/6",
          data: voornemen_6,
          children: [],
        },
      ],
    },
    {
      title: "2. MER-procedure",
      link: "/energietransitie/2",
      data: mer,
      children: [
        {
          title: "2.1. Aanleiding (m.e.r.-plicht)",
          link: "/energietransitie/2/1",
          data: mer_2_1,
          children: [],
        },
        {
          title: "2.2. Procedure",
          link: "/energietransitie/2/2",
          data: mer_2_2,
          children: [],
        },
        {
          title: "2.3. Vervolg",
          link: "/energietransitie/2/3",
          data: mer_2_3,
          children: [],
        },
      ],
    },
    {
      title: "3. Kaders vanuit wetgeving, beleid en richtlijnen ",
      link: "/energietransitie/3",
      data: kaders,
      children: [
        {
          title: "3.1. Nationaal",
          // link: "/energietransitie/3#section1",
          link: "/energietransitie/3/1",
          data: kaders_3_1,
          children: [],
        },
        {
          title: "3.2. Provinciaal",
          link: "/energietransitie/3/2",
          data: kaders_3_2,
          children: [],
        },
        {
          title: "3.3. Regionaal",
          link: "/energietransitie/3/3",
          data: kaders_3_3,
          children: [],
        },
      ],
    },
    {
      title: "4. Effectanalyse zoekgebieden zon en wind ",
      link: "/energietransitie/4",
      data: analyse_4,
      children: [
        {
          title: "4.1. Analyse Natura 2000-gebieden en stikstofoverschrijding",
          link: "/energietransitie/4/1",
          data: analyse_4_1,
          children: [],
        },
        {
          title: "4.2. Analyse Natuurnetwerk Nederland (NNN)",
          link: "/energietransitie/4/2",
          data: analyse_4_2,
          children: [],
        },
        {
          title: "4.3. Analyse overige gebieden (weidevogel-, ganzenrust- en stiltegebieden)",
          link: "/energietransitie/4/3",
          data: analyse_4_3,
          children: [],
        },
        {
          title: "4.4. Analyse soorten (vogels en vleermuizen)",
          link: "/energietransitie/4/4",
          data: analyse_4_4,
          children: [],
        },
        {
          title: "4.5. Analyse geluid",
          link: "/energietransitie/4/5",
          data: analyse_4_5,
          children: [],
        },
        {
          title: "4.6. Analyse woningbouwlocaties",
          link: "/energietransitie/4/6",
          data: analyse_4_6,
          children: [],
        },
        {
          title: "4.7. Analyse externe veiligheid",
          link: "/energietransitie/4/7",
          data: analyse_4_7,
          children: [],
        },
        {
          title: "4.8. Analyse inpassing energie-infrastructuur",
          link: "/energietransitie/4/8",
          data: analyse_4_8,
          children: [],
        },
        {
          title: "4.9. Analyse drinkwatergebieden",
          link: "/energietransitie/4/9",
          data: analyse_4_9,
          children: [],
        },
        {
          title: "4.10. Analyse landschappelijke inpassing",
          link: "/energietransitie/4/10",
          data: analyse_4_10,
          children: [
            {
              title: "4.10.1. Zonne-energie",
              link: "/energietransitie/4/10/1",
              data: analyse_4_10_1
            },
            {
              title: "4.10.2. Windenergie",
              link: "/energietransitie/4/10/2",
              data: analyse_4_10_2
            },
            {
              title: "4.10.3. Toetsen of ontwerpen? ",
              link: "/energietransitie/4/10/3",
              data: analyse_4_10_3
            },
          ]

        },
        {
          title: "4.11. Samenvatting effectanalyse zoekgebieden zon en wind",
          link: "/energietransitie/4/11",
          data: analyse_4_11,
          children: [],
        },
      ],
    },
    {
      title: "5. Beoordeling alternatieven",
      link: "/energietransitie/5",
      data: alternatief,
      children: [
        {
          title: "5.1. Vier alternatieven",
          link: "/energietransitie/5/1",
          data: alternatief_1,
          children: [],
        },
        {
          title: "5.2. Werkwijze alternatiefontwikkeling",
          link: "/energietransitie/5/2",
          data: alternatief_2,
          children: [],
        },
        {
          title: "5.3. Alternatief 1: RES 1.0- basis",
          link: "/energietransitie/5/3",
          data: alternatief_3,
          children: [],
        },
        {
          title: "5.4. Alternatief 2: RES 1.0- na besluitvorming",
          link: "/energietransitie/5/4",
          data: alternatief_4,
          children: [],
        },
        {
          title: "5.5. Alternatief 3: landschap",
          link: "/energietransitie/5/5",
          data: alternatief_5,
          children: [],
        },
        {
          title: "5.6. Alternatief 4: haalbaar en betaalbaar (netcapaciteit)",
          link: "/energietransitie/5/6",
          data: alternatief_6,
          children: [],
        },
        {
          title: "5.7. Effectbeoordeling alternatieven",
          link: "/energietransitie/5/7",
          data: alternatief_7,
          children: [],
        },
        {
          title: "5.8. Inzichten beoordeling alternatieven",
          link: "/energietransitie/5/8",
          data: alternatief_8,
          children: [],
        },

      ],
    },
    {
      title: "6. Kennisleemtes en vervolgonderzoek",
      link: "/energietransitie/6",
      data: kennisleemtes,
      children: [
        {
          title: "6.1. Leemten in kennis",
          link: "/energietransitie/6/1",
          data: kennisleemtes_1,
          children: [],
        },
        {
          title: "6.2. Monitoring en evaluatie",
          link: "/energietransitie/6/2",
          data: kennisleemtes_2,
          children: [],
        },
      ],
    },
    {
      title: "Versiebeheer",
      link: "/energietransitie/versiebeheer",
      data: versiebeheer,
      children: [],
    },    
  ],
};

export default data
